import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import djiBridge from '../utils/cloud-sample-DjiBridge';
import { EComponentName } from '../utils/cloud-sample-cloudModule';
import { setAuth } from '../utils/auth';
import { ELocalStorageKey, API_ENDPOINTS } from '../utils/constants';

const NewPilotLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    try {
      const appId = window.APP_CONFIG?.dji?.appId || '';
      const appKey = window.APP_CONFIG?.dji?.appKey || '';
      const appLicense = window.APP_CONFIG?.dji?.license || '';
      djiBridge.platformVerifyLicense(appId, appKey, appLicense);
      setIsVerified(djiBridge.isPlatformVerifySuccess());
    } catch (e) {
      setIsVerified(false);
    }

    const savedUser = localStorage.getItem('pilot_last_username');
    const savedPass = localStorage.getItem('pilot_last_password');
    if (savedUser) setUsername(savedUser);
    if (savedPass) setPassword(savedPass);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!isVerified) return;
    setLoading(true);
    setError(null);

    const storedUser = localStorage.getItem('pilot_last_username');
    if (storedUser && storedUser !== username) {
      localStorage.clear();
    }

    try {
      const response = await axios.post(API_ENDPOINTS.LOGIN, { username, password });
      if (response.data?.code !== 0) {
        setError(response.data.message || 'Login failed.');
        setLoading(false);
        return;
      }

      const data = response.data.data;
      const token = data.token || data.access_token;
      if (!token) {
        setError('No token received.');
        setLoading(false);
        return;
      }

      setAuth(token, data);
      localStorage.setItem(ELocalStorageKey.Token, token);
      localStorage.setItem(ELocalStorageKey.Username, data.username);
      localStorage.setItem(ELocalStorageKey.UserId, data.user_id || data.userId);
      localStorage.setItem(ELocalStorageKey.WorkspaceId,
        data.workspace?.workspace_id || data.workspace_id || '');
      localStorage.setItem('pilot_last_username', username);
      localStorage.setItem('pilot_last_password', password);

      try {
        djiBridge.setComponentParam(EComponentName.Api, {
          host: window.location.origin,
          token: token
        });
        djiBridge.loadComponent(EComponentName.Api, djiBridge.getComponentParam(EComponentName.Api));
        djiBridge.setToken(token);
      } catch (bridgeErr) {
        console.warn('DJI Bridge calls skipped:', bridgeErr.message);
      }

      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Login failed.');
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
      <div style={{ width: '100%', maxWidth: '360px', backgroundColor: '#fff', padding: '32px 24px', border: '1px solid #cfd8dc' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '24px', fontSize: '18px', color: '#1a2332' }}>Pilot Login</h2>

        {error && (
          <div style={{ padding: '8px 12px', marginBottom: '16px', backgroundColor: '#ffebee', color: '#c62828', fontSize: '13px', border: '1px solid #ef9a9a' }}>{error}</div>
        )}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', color: '#1a2332' }}>Username</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} disabled={loading}
              style={{ width: '100%', padding: '8px', border: '1px solid #cfd8dc', fontSize: '14px', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', color: '#1a2332' }}>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading}
              style={{ width: '100%', padding: '8px', border: '1px solid #cfd8dc', fontSize: '14px', boxSizing: 'border-box' }} />
          </div>
          <button type="submit" disabled={loading || !isVerified}
            style={{ width: '100%', padding: '10px', backgroundColor: isVerified ? '#1565c0' : '#90a4ae', color: '#fff', border: 'none', fontSize: '14px', fontWeight: 600, cursor: isVerified && !loading ? 'pointer' : 'default' }}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewPilotLogin;
